module.exports = __webpack_public_path__ + "static/media/storage.faafb83b.svg";